var _style, _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _polygon123, _polygon124, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _polygon157, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _polygon168, _polygon169, _polygon170, _polygon171, _polygon172, _polygon173, _polygon174, _polygon175, _polygon176, _polygon177, _polygon178, _polygon179, _polygon180, _polygon181, _polygon182, _polygon183, _polygon184, _polygon185, _polygon186, _polygon187, _polygon188, _polygon189, _polygon190, _polygon191, _polygon192, _polygon193, _polygon194, _polygon195, _polygon196, _polygon197, _polygon198, _polygon199, _polygon200, _polygon201, _defs2, _polygon202, _polygon203, _polygon204, _polygon205, _polygon206, _polygon207, _polygon208, _polygon209, _polygon210, _polygon211, _polygon212, _polygon213, _polygon214, _polygon215, _polygon216, _polygon217, _polygon218, _polygon219, _polygon220, _polygon221, _polygon222, _polygon223, _polygon224, _polygon225, _polygon226, _polygon227, _polygon228, _polygon229, _polygon230, _polygon231, _polygon232, _polygon233, _polygon234, _polygon235, _polygon236, _polygon237, _polygon238, _polygon239, _polygon240, _polygon241, _polygon242, _polygon243, _polygon244, _polygon245, _polygon246, _polygon247, _polygon248, _polygon249, _polygon250, _polygon251, _polygon252, _polygon253, _polygon254, _polygon255, _polygon256, _polygon257, _polygon258, _polygon259, _polygon260, _polygon261, _polygon262, _polygon263, _polygon264, _polygon265, _polygon266, _polygon267, _polygon268, _polygon269, _polygon270, _polygon271, _polygon272, _polygon273, _polygon274, _polygon275, _polygon276, _polygon277, _polygon278, _polygon279, _polygon280, _polygon281, _polygon282, _polygon283, _polygon284, _polygon285, _polygon286, _polygon287, _polygon288, _polygon289, _polygon290, _polygon291, _polygon292, _polygon293, _polygon294, _polygon295, _polygon296, _polygon297, _polygon298, _polygon299, _polygon300, _polygon301, _polygon302, _polygon303, _polygon304, _polygon305, _polygon306, _polygon307, _polygon308, _polygon309, _polygon310, _polygon311, _polygon312, _polygon313, _polygon314, _polygon315, _polygon316, _polygon317, _polygon318, _polygon319, _polygon320, _polygon321, _polygon322, _polygon323, _polygon324, _polygon325, _polygon326, _polygon327, _polygon328, _polygon329, _polygon330, _polygon331, _polygon332, _polygon333, _polygon334, _polygon335, _polygon336, _polygon337;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 147 71.7",
    style: {
      enableBackground: "new 0 0 147 71.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#0589FD;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#0689FD;}\n\t.st2{clip-path:url(#SVGID_2_);fill:#0789FC;}\n\t.st3{clip-path:url(#SVGID_2_);fill:#0889FC;}\n\t.st4{clip-path:url(#SVGID_2_);fill:#0989FB;}\n\t.st5{clip-path:url(#SVGID_2_);fill:#0A89FB;}\n\t.st6{clip-path:url(#SVGID_2_);fill:#0B89FB;}\n\t.st7{clip-path:url(#SVGID_2_);fill:#0C89FA;}\n\t.st8{clip-path:url(#SVGID_2_);fill:#0D89FA;}\n\t.st9{clip-path:url(#SVGID_2_);fill:#0E89F9;}\n\t.st10{clip-path:url(#SVGID_2_);fill:#0F89F9;}\n\t.st11{clip-path:url(#SVGID_2_);fill:#1089F9;}\n\t.st12{clip-path:url(#SVGID_2_);fill:#1189F8;}\n\t.st13{clip-path:url(#SVGID_2_);fill:#1289F8;}\n\t.st14{clip-path:url(#SVGID_2_);fill:#1389F7;}\n\t.st15{clip-path:url(#SVGID_2_);fill:#1489F7;}\n\t.st16{clip-path:url(#SVGID_2_);fill:#1589F6;}\n\t.st17{clip-path:url(#SVGID_2_);fill:#1688F6;}\n\t.st18{clip-path:url(#SVGID_2_);fill:#1788F6;}\n\t.st19{clip-path:url(#SVGID_2_);fill:#1888F5;}\n\t.st20{clip-path:url(#SVGID_2_);fill:#1988F5;}\n\t.st21{clip-path:url(#SVGID_2_);fill:#1A88F4;}\n\t.st22{clip-path:url(#SVGID_2_);fill:#1B88F4;}\n\t.st23{clip-path:url(#SVGID_2_);fill:#1C88F4;}\n\t.st24{clip-path:url(#SVGID_2_);fill:#1D88F3;}\n\t.st25{clip-path:url(#SVGID_2_);fill:#1E88F3;}\n\t.st26{clip-path:url(#SVGID_2_);fill:#1F88F2;}\n\t.st27{clip-path:url(#SVGID_2_);fill:#2088F2;}\n\t.st28{clip-path:url(#SVGID_2_);fill:#2188F2;}\n\t.st29{clip-path:url(#SVGID_2_);fill:#2288F1;}\n\t.st30{clip-path:url(#SVGID_2_);fill:#2388F1;}\n\t.st31{clip-path:url(#SVGID_2_);fill:#2488F0;}\n\t.st32{clip-path:url(#SVGID_2_);fill:#2588F0;}\n\t.st33{clip-path:url(#SVGID_2_);fill:#2688F0;}\n\t.st34{clip-path:url(#SVGID_2_);fill:#2788EF;}\n\t.st35{clip-path:url(#SVGID_2_);fill:#2888EF;}\n\t.st36{clip-path:url(#SVGID_2_);fill:#2988EE;}\n\t.st37{clip-path:url(#SVGID_2_);fill:#2A88EE;}\n\t.st38{clip-path:url(#SVGID_2_);fill:#2B88ED;}\n\t.st39{clip-path:url(#SVGID_2_);fill:#2C88ED;}\n\t.st40{clip-path:url(#SVGID_2_);fill:#2D88ED;}\n\t.st41{clip-path:url(#SVGID_2_);fill:#2E88EC;}\n\t.st42{clip-path:url(#SVGID_2_);fill:#2F88EC;}\n\t.st43{clip-path:url(#SVGID_2_);fill:#3088EB;}\n\t.st44{clip-path:url(#SVGID_2_);fill:#3188EB;}\n\t.st45{clip-path:url(#SVGID_2_);fill:#3288EB;}\n\t.st46{clip-path:url(#SVGID_2_);fill:#3388EA;}\n\t.st47{clip-path:url(#SVGID_2_);fill:#3488EA;}\n\t.st48{clip-path:url(#SVGID_2_);fill:#3588E9;}\n\t.st49{clip-path:url(#SVGID_2_);fill:#3688E9;}\n\t.st50{clip-path:url(#SVGID_2_);fill:#3887E9;}\n\t.st51{clip-path:url(#SVGID_2_);fill:#3987E8;}\n\t.st52{clip-path:url(#SVGID_2_);fill:#3A87E8;}\n\t.st53{clip-path:url(#SVGID_2_);fill:#3B87E7;}\n\t.st54{clip-path:url(#SVGID_2_);fill:#3C87E7;}\n\t.st55{clip-path:url(#SVGID_2_);fill:#3D87E7;}\n\t.st56{clip-path:url(#SVGID_2_);fill:#3E87E6;}\n\t.st57{clip-path:url(#SVGID_2_);fill:#3F87E6;}\n\t.st58{clip-path:url(#SVGID_2_);fill:#4087E5;}\n\t.st59{clip-path:url(#SVGID_2_);fill:#4187E5;}\n\t.st60{clip-path:url(#SVGID_2_);fill:#4287E5;}\n\t.st61{clip-path:url(#SVGID_2_);fill:#4387E4;}\n\t.st62{clip-path:url(#SVGID_2_);fill:#4487E4;}\n\t.st63{clip-path:url(#SVGID_2_);fill:#4587E3;}\n\t.st64{clip-path:url(#SVGID_2_);fill:#4687E3;}\n\t.st65{clip-path:url(#SVGID_2_);fill:#4787E2;}\n\t.st66{clip-path:url(#SVGID_2_);fill:#4887E2;}\n\t.st67{clip-path:url(#SVGID_2_);fill:#4987E2;}\n\t.st68{clip-path:url(#SVGID_2_);fill:#4A87E1;}\n\t.st69{clip-path:url(#SVGID_2_);fill:#4B87E1;}\n\t.st70{clip-path:url(#SVGID_2_);fill:#4C87E0;}\n\t.st71{clip-path:url(#SVGID_2_);fill:#4D87E0;}\n\t.st72{clip-path:url(#SVGID_2_);fill:#4E87E0;}\n\t.st73{clip-path:url(#SVGID_2_);fill:#4F87DF;}\n\t.st74{clip-path:url(#SVGID_2_);fill:#5087DF;}\n\t.st75{clip-path:url(#SVGID_2_);fill:#5187DE;}\n\t.st76{clip-path:url(#SVGID_2_);fill:#5287DE;}\n\t.st77{clip-path:url(#SVGID_2_);fill:#5387DE;}\n\t.st78{clip-path:url(#SVGID_2_);fill:#5487DD;}\n\t.st79{clip-path:url(#SVGID_2_);fill:#5587DD;}\n\t.st80{clip-path:url(#SVGID_2_);fill:#5687DC;}\n\t.st81{clip-path:url(#SVGID_2_);fill:#5787DC;}\n\t.st82{clip-path:url(#SVGID_2_);fill:#5886DC;}\n\t.st83{clip-path:url(#SVGID_2_);fill:#5986DB;}\n\t.st84{clip-path:url(#SVGID_2_);fill:#5A86DB;}\n\t.st85{clip-path:url(#SVGID_2_);fill:#5B86DA;}\n\t.st86{clip-path:url(#SVGID_2_);fill:#5C86DA;}\n\t.st87{clip-path:url(#SVGID_2_);fill:#5D86D9;}\n\t.st88{clip-path:url(#SVGID_2_);fill:#5E86D9;}\n\t.st89{clip-path:url(#SVGID_2_);fill:#5F86D9;}\n\t.st90{clip-path:url(#SVGID_2_);fill:#6086D8;}\n\t.st91{clip-path:url(#SVGID_2_);fill:#6186D8;}\n\t.st92{clip-path:url(#SVGID_2_);fill:#6286D7;}\n\t.st93{clip-path:url(#SVGID_2_);fill:#6386D7;}\n\t.st94{clip-path:url(#SVGID_2_);fill:#6486D7;}\n\t.st95{clip-path:url(#SVGID_2_);fill:#6586D6;}\n\t.st96{clip-path:url(#SVGID_2_);fill:#6686D6;}\n\t.st97{clip-path:url(#SVGID_2_);fill:#6786D5;}\n\t.st98{clip-path:url(#SVGID_2_);fill:#6886D5;}\n\t.st99{clip-path:url(#SVGID_4_);fill:#6386D7;}\n\t.st100{clip-path:url(#SVGID_4_);fill:#6486D7;}\n\t.st101{clip-path:url(#SVGID_4_);fill:#6586D6;}\n\t.st102{clip-path:url(#SVGID_4_);fill:#6686D6;}\n\t.st103{clip-path:url(#SVGID_4_);fill:#6786D6;}\n\t.st104{clip-path:url(#SVGID_4_);fill:#6886D5;}\n\t.st105{clip-path:url(#SVGID_4_);fill:#6986D5;}\n\t.st106{clip-path:url(#SVGID_4_);fill:#6A86D4;}\n\t.st107{clip-path:url(#SVGID_4_);fill:#6B86D4;}\n\t.st108{clip-path:url(#SVGID_4_);fill:#6C86D4;}\n\t.st109{clip-path:url(#SVGID_4_);fill:#6D86D3;}\n\t.st110{clip-path:url(#SVGID_4_);fill:#6E86D3;}\n\t.st111{clip-path:url(#SVGID_4_);fill:#6F86D2;}\n\t.st112{clip-path:url(#SVGID_4_);fill:#7086D2;}\n\t.st113{clip-path:url(#SVGID_4_);fill:#7186D2;}\n\t.st114{clip-path:url(#SVGID_4_);fill:#7285D1;}\n\t.st115{clip-path:url(#SVGID_4_);fill:#7385D1;}\n\t.st116{clip-path:url(#SVGID_4_);fill:#7485D0;}\n\t.st117{clip-path:url(#SVGID_4_);fill:#7585D0;}\n\t.st118{clip-path:url(#SVGID_4_);fill:#7685CF;}\n\t.st119{clip-path:url(#SVGID_4_);fill:#7785CF;}\n\t.st120{clip-path:url(#SVGID_4_);fill:#7885CF;}\n\t.st121{clip-path:url(#SVGID_4_);fill:#7985CE;}\n\t.st122{clip-path:url(#SVGID_4_);fill:#7A85CE;}\n\t.st123{clip-path:url(#SVGID_4_);fill:#5586DD;}\n\t.st124{clip-path:url(#SVGID_4_);fill:#5686DC;}\n\t.st125{clip-path:url(#SVGID_4_);fill:#5786DC;}\n\t.st126{clip-path:url(#SVGID_4_);fill:#5886DC;}\n\t.st127{clip-path:url(#SVGID_4_);fill:#5986DB;}\n\t.st128{clip-path:url(#SVGID_4_);fill:#5A86DB;}\n\t.st129{clip-path:url(#SVGID_4_);fill:#5B86DA;}\n\t.st130{clip-path:url(#SVGID_4_);fill:#5C86DA;}\n\t.st131{clip-path:url(#SVGID_4_);fill:#5D86DA;}\n\t.st132{clip-path:url(#SVGID_4_);fill:#5E86D9;}\n\t.st133{clip-path:url(#SVGID_4_);fill:#5F86D9;}\n\t.st134{clip-path:url(#SVGID_4_);fill:#6086D8;}\n\t.st135{clip-path:url(#SVGID_4_);fill:#6186D8;}\n\t.st136{clip-path:url(#SVGID_4_);fill:#4C87E1;}\n\t.st137{clip-path:url(#SVGID_4_);fill:#4D87E0;}\n\t.st138{clip-path:url(#SVGID_4_);fill:#4E87E0;}\n\t.st139{clip-path:url(#SVGID_4_);fill:#4F87DF;}\n\t.st140{clip-path:url(#SVGID_4_);fill:#5087DF;}\n\t.st141{clip-path:url(#SVGID_4_);fill:#5187DF;}\n\t.st142{clip-path:url(#SVGID_4_);fill:#5286DE;}\n\t.st143{clip-path:url(#SVGID_4_);fill:#5386DE;}\n\t.st144{clip-path:url(#SVGID_4_);fill:#4187E5;}\n\t.st145{clip-path:url(#SVGID_4_);fill:#4287E5;}\n\t.st146{clip-path:url(#SVGID_4_);fill:#4387E4;}\n\t.st147{clip-path:url(#SVGID_4_);fill:#4487E4;}\n\t.st148{clip-path:url(#SVGID_4_);fill:#4587E3;}\n\t.st149{clip-path:url(#SVGID_4_);fill:#4687E3;}\n\t.st150{clip-path:url(#SVGID_4_);fill:#4787E3;}\n\t.st151{clip-path:url(#SVGID_4_);fill:#4887E2;}\n\t.st152{clip-path:url(#SVGID_4_);fill:#4987E2;}\n\t.st153{clip-path:url(#SVGID_4_);fill:#4A87E1;}\n\t.st154{clip-path:url(#SVGID_4_);fill:#4B87E1;}\n\t.st155{clip-path:url(#SVGID_4_);fill:#2A88EE;}\n\t.st156{clip-path:url(#SVGID_4_);fill:#2B88EE;}\n\t.st157{clip-path:url(#SVGID_4_);fill:#2C88ED;}\n\t.st158{clip-path:url(#SVGID_4_);fill:#2D88ED;}\n\t.st159{clip-path:url(#SVGID_4_);fill:#2E88EC;}\n\t.st160{clip-path:url(#SVGID_4_);fill:#2F88EC;}\n\t.st161{clip-path:url(#SVGID_4_);fill:#3088EC;}\n\t.st162{clip-path:url(#SVGID_4_);fill:#3187EB;}\n\t.st163{clip-path:url(#SVGID_4_);fill:#3287EB;}\n\t.st164{clip-path:url(#SVGID_4_);fill:#3387EA;}\n\t.st165{clip-path:url(#SVGID_4_);fill:#3487EA;}\n\t.st166{clip-path:url(#SVGID_4_);fill:#3587E9;}\n\t.st167{clip-path:url(#SVGID_4_);fill:#3687E9;}\n\t.st168{clip-path:url(#SVGID_4_);fill:#3787E9;}\n\t.st169{clip-path:url(#SVGID_4_);fill:#3887E8;}\n\t.st170{clip-path:url(#SVGID_4_);fill:#3987E8;}\n\t.st171{clip-path:url(#SVGID_4_);fill:#3A87E7;}\n\t.st172{clip-path:url(#SVGID_4_);fill:#3B87E7;}\n\t.st173{clip-path:url(#SVGID_4_);fill:#3C87E7;}\n\t.st174{clip-path:url(#SVGID_4_);fill:#3D87E6;}\n\t.st175{clip-path:url(#SVGID_4_);fill:#3E87E6;}\n\t.st176{clip-path:url(#SVGID_4_);fill:#3F87E5;}\n\t.st177{clip-path:url(#SVGID_4_);fill:#1C88F4;}\n\t.st178{clip-path:url(#SVGID_4_);fill:#1D88F3;}\n\t.st179{clip-path:url(#SVGID_4_);fill:#1E88F3;}\n\t.st180{clip-path:url(#SVGID_4_);fill:#1F88F2;}\n\t.st181{clip-path:url(#SVGID_4_);fill:#2088F2;}\n\t.st182{clip-path:url(#SVGID_4_);fill:#2188F2;}\n\t.st183{clip-path:url(#SVGID_4_);fill:#2288F1;}\n\t.st184{clip-path:url(#SVGID_4_);fill:#2388F1;}\n\t.st185{clip-path:url(#SVGID_4_);fill:#2488F0;}\n\t.st186{clip-path:url(#SVGID_4_);fill:#1688F6;}\n\t.st187{clip-path:url(#SVGID_4_);fill:#1788F6;}\n\t.st188{clip-path:url(#SVGID_4_);fill:#1888F5;}\n\t.st189{clip-path:url(#SVGID_4_);fill:#1988F5;}\n\t.st190{clip-path:url(#SVGID_4_);fill:#1A88F4;}\n\t.st191{clip-path:url(#SVGID_4_);fill:#1B88F4;}\n\t.st192{clip-path:url(#SVGID_4_);fill:#2588F0;}\n\t.st193{clip-path:url(#SVGID_4_);fill:#2688F0;}\n\t.st194{clip-path:url(#SVGID_4_);fill:#2788EF;}\n\t.st195{clip-path:url(#SVGID_4_);fill:#2888EF;}\n\t.st196{clip-path:url(#SVGID_4_);fill:#2988EE;}\n\t.st197{clip-path:url(#SVGID_4_);fill:#0389FE;}\n\t.st198{clip-path:url(#SVGID_4_);fill:#0489FD;}\n\t.st199{clip-path:url(#SVGID_4_);fill:#0589FD;}\n\t.st200{clip-path:url(#SVGID_4_);fill:#0689FD;}\n\t.st201{clip-path:url(#SVGID_4_);fill:#0789FC;}\n\t.st202{clip-path:url(#SVGID_4_);fill:#0889FC;}\n\t.st203{clip-path:url(#SVGID_4_);fill:#0989FB;}\n\t.st204{clip-path:url(#SVGID_4_);fill:#0A89FB;}\n\t.st205{clip-path:url(#SVGID_4_);fill:#0B89FB;}\n\t.st206{clip-path:url(#SVGID_4_);fill:#0C89FA;}\n\t.st207{clip-path:url(#SVGID_4_);fill:#0D89FA;}\n\t.st208{clip-path:url(#SVGID_4_);fill:#0E89F9;}\n\t.st209{clip-path:url(#SVGID_4_);fill:#0F89F9;}\n\t.st210{clip-path:url(#SVGID_4_);fill:#1089F9;}\n\t.st211{clip-path:url(#SVGID_4_);fill:#1188F8;}\n\t.st212{clip-path:url(#SVGID_4_);fill:#1288F8;}\n\t.st213{clip-path:url(#SVGID_4_);fill:#1388F7;}\n\t.st214{clip-path:url(#SVGID_4_);fill:#1488F7;}\n\t.st215{clip-path:url(#SVGID_4_);fill:#1588F6;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Union_6_-_Outline"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M117.5,66l7-7h9.5c5,0,9-4,9-9V13c0-5-4-9-9-9H13c-5,0-9,4-9,9v37c0,5,4,9,9,9h97.5L117.5,66 M117.5,71.7 l-8.7-8.7H13C5.8,63,0,57.2,0,50V13C0,5.8,5.8,0,13,0h121c7.2,0,13,5.8,13,13v37c0,7.2-5.8,13-13,13h-7.8L117.5,71.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9,0 0,5.1 0,0  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "11.5,0 0,6.6 0,5.1 9,0  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14,0 0,8 0,6.6 11.5,0  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "16.5,0 0,9.4 0,8 14,0  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "19,0 0,10.9 0,9.4 16.5,0  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "21.6,0 0,12.3 0,10.9 19,0  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "24.1,0 0,13.7 0,12.3 21.6,0  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "26.6,0 0,15.2 0,13.7 24.1,0  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "29.1,0 0,16.6 0,15.2 26.6,0  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "31.6,0 0,18 0,16.6 29.1,0  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "34.1,0 0,19.5 0,18 31.6,0  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "36.6,0 0,20.9 0,19.5 34.1,0  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "39.2,0 0,22.4 0,20.9 36.6,0  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "41.7,0 0,23.8 0,22.4 39.2,0  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "44.2,0 0,25.2 0,23.8 41.7,0  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "46.7,0 0,26.7 0,25.2 44.2,0  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "49.2,0 0,28.1 0,26.7 46.7,0  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "51.7,0 0,29.5 0,28.1 49.2,0  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "54.2,0 0,31 0,29.5 51.7,0  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "56.7,0 0,32.4 0,31 54.2,0  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "59.3,0 0,33.8 0,32.4 56.7,0  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "61.8,0 0,35.3 0,33.8 59.3,0  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "64.3,0 0,36.7 0,35.3 61.8,0  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "66.8,0 0,38.1 0,36.7 64.3,0  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "69.3,0 0,39.6 0,38.1 66.8,0  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "71.8,0 0,41 0,39.6 69.3,0  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "74.3,0 0,42.5 0,41 71.8,0  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "76.9,0 0,43.9 0,42.5 74.3,0  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "79.4,0 0,45.3 0,43.9 76.9,0  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "81.9,0 0,46.8 0,45.3 79.4,0  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "84.4,0 0,48.2 0,46.8 81.9,0  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "86.9,0 0,49.6 0,48.2 84.4,0  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "89.4,0 0,51.1 0,49.6 86.9,0  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "91.9,0 0,52.5 0,51.1 89.4,0  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "94.5,0 0,53.9 0,52.5 91.9,0  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "97,0 0,55.4 0,53.9 94.5,0  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "99.5,0 0,56.8 0,55.4 97,0  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "102,0 0,58.2 0,56.8 99.5,0  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "104.5,0 0,59.7 0,58.2 102,0  "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "107,0 0,61.1 0,59.7 104.5,0  "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "109.5,0 0,62.5 0,61.1 107,0  "
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "112,0 0,64 0,62.5 109.5,0  "
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "114.6,0 0,65.4 0,64 112,0  "
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "117.1,0 0,66.9 0,65.4 114.6,0  "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "119.6,0 0,68.3 0,66.9 117.1,0  "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "122.1,0 0,69.7 0,68.3 119.6,0  "
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "124.6,0 0,71.2 0,69.7 122.1,0  "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "127.1,0 1.6,71.7 0,71.7 0,71.2 124.6,0  "
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "129.6,0 4.1,71.7 1.6,71.7 127.1,0  "
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "132.2,0 6.6,71.7 4.1,71.7 129.6,0  "
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "134.7,0 9.1,71.7 6.6,71.7 132.2,0  "
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "137.2,0 11.7,71.7 9.1,71.7 134.7,0  "
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "139.7,0 14.2,71.7 11.7,71.7 137.2,0  "
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "142.2,0 16.7,71.7 14.2,71.7 139.7,0  "
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "144.7,0 19.2,71.7 16.7,71.7 142.2,0  "
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "147,0.1 21.7,71.7 19.2,71.7 144.7,0 147,0  "
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "147,1.6 24.2,71.7 21.7,71.7 147,0.1  "
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "147,3 26.7,71.7 24.2,71.7 147,1.6  "
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "147,4.4 29.3,71.7 26.7,71.7 147,3  "
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "147,5.9 31.8,71.7 29.3,71.7 147,4.4  "
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "147,7.3 34.3,71.7 31.8,71.7 147,5.9  "
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "147,8.7 36.8,71.7 34.3,71.7 147,7.3  "
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "147,10.2 39.3,71.7 36.8,71.7 147,8.7  "
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "147,11.6 41.8,71.7 39.3,71.7 147,10.2  "
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "147,13.1 44.3,71.7 41.8,71.7 147,11.6  "
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "147,14.5 46.8,71.7 44.3,71.7 147,13.1  "
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "147,15.9 49.4,71.7 46.8,71.7 147,14.5  "
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "147,17.4 51.9,71.7 49.4,71.7 147,15.9  "
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "147,18.8 54.4,71.7 51.9,71.7 147,17.4  "
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "147,20.2 56.9,71.7 54.4,71.7 147,18.8  "
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "147,21.7 59.4,71.7 56.9,71.7 147,20.2  "
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "147,23.1 61.9,71.7 59.4,71.7 147,21.7  "
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "147,24.5 64.4,71.7 61.9,71.7 147,23.1  "
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "147,26 67,71.7 64.4,71.7 147,24.5  "
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "147,27.4 69.5,71.7 67,71.7 147,26  "
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "147,28.8 72,71.7 69.5,71.7 147,27.4  "
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "147,30.3 74.5,71.7 72,71.7 147,28.8  "
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "147,31.7 77,71.7 74.5,71.7 147,30.3  "
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "147,33.1 79.5,71.7 77,71.7 147,31.7  "
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "147,34.6 82,71.7 79.5,71.7 147,33.1  "
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "147,36 84.6,71.7 82,71.7 147,34.6  "
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "147,37.5 87.1,71.7 84.6,71.7 147,36  "
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "147,38.9 89.6,71.7 87.1,71.7 147,37.5  "
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "147,40.3 92.1,71.7 89.6,71.7 147,38.9  "
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "147,41.8 94.6,71.7 92.1,71.7 147,40.3  "
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "147,43.2 97.1,71.7 94.6,71.7 147,41.8  "
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "147,44.6 99.6,71.7 97.1,71.7 147,43.2  "
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "147,46.1 102.1,71.7 99.6,71.7 147,44.6  "
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "147,47.5 104.7,71.7 102.1,71.7 147,46.1  "
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "147,48.9 107.2,71.7 104.7,71.7 147,47.5  "
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "147,50.4 109.7,71.7 107.2,71.7 147,48.9  "
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "147,51.8 112.2,71.7 109.7,71.7 147,50.4  "
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "147,53.2 114.7,71.7 112.2,71.7 147,51.8  "
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "147,54.7 117.2,71.7 114.7,71.7 147,53.2  "
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "147,56.1 119.7,71.7 117.2,71.7 147,54.7  "
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "147,57.6 122.3,71.7 119.7,71.7 147,56.1  "
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "147,59 124.8,71.7 122.3,71.7 147,57.6  "
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "147,60.4 127.3,71.7 124.8,71.7 147,59  "
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "147,61.9 129.8,71.7 127.3,71.7 147,60.4  "
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "147,63.3 132.3,71.7 129.8,71.7 147,61.9  "
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "132.3,71.7 147,63.3 147,71.7  "
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "4.5,4 4,4.3 4,4  "
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "7,4 4,5.7 4,4.3 4.5,4  "
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "9.5,4 4,7.2 4,5.7 7,4  "
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "12,4 4,8.6 4,7.2 9.5,4  "
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "14.6,4 4,10 4,8.6 12,4  "
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "17.1,4 4,11.5 4,10 14.6,4  "
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "19.6,4 4,12.9 4,11.5 17.1,4  "
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "22.1,4 4,14.3 4,12.9 19.6,4  "
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "24.6,4 4,15.8 4,14.3 22.1,4  "
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "27.1,4 4,17.2 4,15.8 24.6,4  "
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "29.6,4 4,18.6 4,17.2 27.1,4  "
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "32.1,4 4,20.1 4,18.6 29.6,4  "
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "34.7,4 4,21.5 4,20.1 32.1,4  "
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "37.2,4 4,22.9 4,21.5 34.7,4  "
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "39.7,4 4,24.4 4,22.9 37.2,4  "
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "42.2,4 4,25.8 4,24.4 39.7,4  "
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "44.7,4 4,27.2 4,25.8 42.2,4  "
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "47.2,4 4,28.7 4,27.2 44.7,4  "
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "49.7,4 4,30.1 4,28.7 47.2,4  "
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "52.3,4 4,31.6 4,30.1 49.7,4  "
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "54.8,4 4,33 4,31.6 52.3,4  "
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "57.3,4 4,34.4 4,33 54.8,4  "
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "59.8,4 4,35.9 4,34.4 57.3,4  "
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "62.3,4 4,37.3 4,35.9 59.8,4  "
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "64.8,4 4,38.7 4,37.3 62.3,4  "
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "67.3,4 4,40.2 4,38.7 64.8,4  "
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "69.9,4 4,41.6 4,40.2 67.3,4  "
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "72.4,4 4,43 4,41.6 69.9,4  "
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "74.9,4 4,44.5 4,43 72.4,4  "
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "77.4,4 4,45.9 4,44.5 74.9,4  "
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "79.9,4 4,47.3 4,45.9 77.4,4  "
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "82.4,4 4,48.8 4,47.3 79.9,4  "
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "84.9,4 4,50.2 4,48.8 82.4,4  "
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "87.4,4 4,51.6 4,50.2 84.9,4  "
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "90,4 4,53.1 4,51.6 87.4,4  "
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "92.5,4 4,54.5 4,53.1 90,4  "
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "95,4 4,56 4,54.5 92.5,4  "
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "97.5,4 4,57.4 4,56 95,4  "
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "100,4 4,58.8 4,57.4 97.5,4  "
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "102.5,4 4,60.3 4,58.8 100,4  "
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "105,4 4,61.7 4,60.3 102.5,4  "
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "107.6,4 4,63.1 4,61.7 105,4  "
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "110.1,4 4,64.6 4,63.1 107.6,4  "
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "112.6,4 4,66 4,64.6 110.1,4  "
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "115.1,4 6.5,66 4,66 4,66 112.6,4  "
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "117.6,4 9,66 6.5,66 115.1,4  "
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "120.1,4 11.5,66 9,66 117.6,4  "
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "122.6,4 14,66 11.5,66 120.1,4  "
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "125.2,4 16.5,66 14,66 122.6,4  "
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "127.7,4 19,66 16.5,66 125.2,4  "
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "130.2,4 21.6,66 19,66 127.7,4  "
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "132.7,4 24.1,66 21.6,66 130.2,4  "
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "135.2,4 26.6,66 24.1,66 132.7,4  "
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "137.7,4 29.1,66 26.6,66 135.2,4  "
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "140.2,4 31.6,66 29.1,66 137.7,4  "
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "142.7,4 34.1,66 31.6,66 140.2,4  "
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "143,5.3 36.6,66 34.1,66 142.7,4 143,4  "
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "143,6.7 39.2,66 36.6,66 143,5.3  "
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "143,8.2 41.7,66 39.2,66 143,6.7  "
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "143,9.6 44.2,66 41.7,66 143,8.2  "
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "143,11 46.7,66 44.2,66 143,9.6  "
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "143,12.5 49.2,66 46.7,66 143,11  "
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "143,13.9 51.7,66 49.2,66 143,12.5  "
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "143,15.3 54.2,66 51.7,66 143,13.9  "
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "143,16.8 56.8,66 54.2,66 143,15.3  "
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "143,18.2 59.3,66 56.8,66 143,16.8  "
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "143,19.6 61.8,66 59.3,66 143,18.2  "
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "143,21.1 64.3,66 61.8,66 143,19.6  "
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "143,22.5 66.8,66 64.3,66 143,21.1  "
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "143,24 69.3,66 66.8,66 143,22.5  "
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "143,25.4 71.8,66 69.3,66 143,24  "
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "143,26.8 74.4,66 71.8,66 143,25.4  "
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "143,28.3 76.9,66 74.4,66 143,26.8  "
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "143,29.7 79.4,66 76.9,66 143,28.3  "
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "143,31.1 81.9,66 79.4,66 143,29.7  "
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "143,32.6 84.4,66 81.9,66 143,31.1  "
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "143,34 86.9,66 84.4,66 143,32.6  "
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "143,35.4 89.4,66 86.9,66 143,34  "
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "143,36.9 91.9,66 89.4,66 143,35.4  "
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "143,38.3 94.5,66 91.9,66 143,36.9  "
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "143,39.7 97,66 94.5,66 143,38.3  "
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "143,41.2 99.5,66 97,66 143,39.7  "
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "143,42.6 102,66 99.5,66 143,41.2  "
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "143,44 104.5,66 102,66 143,42.6  "
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "143,45.5 107,66 104.5,66 143,44  "
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "143,46.9 109.5,66 107,66 143,45.5  "
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "143,48.4 112.1,66 109.5,66 143,46.9  "
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "143,49.8 114.6,66 112.1,66 143,48.4  "
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "143,51.2 117.1,66 114.6,66 143,49.8  "
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "143,52.7 119.6,66 117.1,66 143,51.2  "
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "143,54.1 122.1,66 119.6,66 143,52.7  "
  })), _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "143,55.5 124.6,66 122.1,66 143,54.1  "
  })), _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "143,57 127.1,66 124.6,66 143,55.5  "
  })), _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "143,58.4 129.7,66 127.1,66 143,57  "
  })), _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "143,59.8 132.2,66 129.7,66 143,58.4  "
  })), _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "143,61.3 134.7,66 132.2,66 143,59.8  "
  })), _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "143,62.7 137.2,66 134.7,66 143,61.3  "
  })), _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "143,64.1 139.7,66 137.2,66 143,62.7  "
  })), _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "143,65.6 142.2,66 139.7,66 143,64.1  "
  })), _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "142.2,66 143,65.6 143,66  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M29.5,19v23.7h-4.2V19H19v-3.9h16.9V19H29.5z M53.2,35H40.7c0,1.3,0.5,2.5,1.4,3.4c0.8,0.8,2,1.3,3.2,1.3 c0.9,0,1.8-0.2,2.5-0.7c0.9-0.8,1.6-1.6,2.2-2.7l3.4,1.9c-0.5,0.8-1,1.6-1.7,2.3c-0.6,0.6-1.2,1.1-1.9,1.6 c-0.7,0.4-1.4,0.7-2.2,0.9c-0.8,0.2-1.7,0.3-2.5,0.3c-2.4,0.1-4.6-0.8-6.3-2.5c-1.6-1.8-2.5-4.2-2.4-6.7 c-0.1-2.4,0.7-4.8,2.3-6.7c1.6-1.7,3.8-2.6,6.1-2.5c2.3-0.1,4.5,0.8,6.1,2.5c1.6,1.9,2.4,4.3,2.2,6.8L53.2,35z M49.1,31.7 c-0.3-2-2.1-3.4-4.1-3.2c-0.5,0-0.9,0.1-1.4,0.2c-0.4,0.1-0.8,0.4-1.2,0.6c-0.4,0.3-0.7,0.6-0.9,1c-0.3,0.4-0.5,0.9-0.6,1.3 L49.1,31.7z M62.3,33.3l-6.3-8h4.8l3.9,5.1l4-5.1h4.9l-6.4,8l7.5,9.4h-4.8l-5.1-6.5l-5.2,6.5h-4.9L62.3,33.3z M81.5,29v13.7h-4 V29h-1.7v-3.8h1.7v-6.4h4v6.4h3.1V29H81.5z M91.4,25.3v17.4h-4V25.3L91.4,25.3z M86.8,18c0-0.7,0.3-1.4,0.8-1.8 c0.5-0.5,1.1-0.8,1.8-0.8c0.7,0,1.4,0.3,1.9,0.8c0.5,0.5,0.8,1.2,0.8,1.8c0,0.7-0.3,1.4-0.8,1.9c-0.5,0.5-1.1,0.8-1.8,0.8 c-0.7,0-1.4-0.3-1.9-0.8C87.1,19.4,86.8,18.7,86.8,18z M100.7,29v13.7h-4V29h-1.4v-3.8h1.4v-6.7c0-2.2,0.4-3.7,1.1-4.7 c1.2-1.3,2.8-2,4.6-1.9c0.9,0,1.8,0.3,2.7,0.6v4.1l-0.4-0.2c-0.7-0.4-1.4-0.6-2.1-0.7c-0.6-0.1-1.2,0.2-1.5,0.8 c-0.3,0.9-0.4,1.9-0.4,2.9v5.8h4.4V29H100.7z M115.9,39.5L108,25.3h4.7l5.3,10l5-10h4.5l-13.9,26.9h-4.6L115.9,39.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "108,25.3 108,25.4 108,25.3  "
  })), _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "109,25.3 108,41.6 108,25.4 108,25.3  "
  })), _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "109.9,25.3 108.3,52.2 108,52.2 108,41.6 109,25.3  "
  })), _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "110.8,25.3 109.3,52.2 108.3,52.2 109.9,25.3  "
  })), _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "111.8,25.3 110.2,52.2 109.3,52.2 110.8,25.3  "
  })), _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "112.7,25.3 111.2,52.2 110.2,52.2 111.8,25.3  "
  })), _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "113.7,25.3 112.1,52.2 111.2,52.2 112.7,25.3  "
  })), _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "114.6,25.3 113.1,52.2 112.1,52.2 113.7,25.3  "
  })), _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "115.6,25.3 114,52.2 113.1,52.2 114.6,25.3  "
  })), _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "116.5,25.3 114.9,52.2 114,52.2 115.6,25.3  "
  })), _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "117.4,25.3 115.9,52.2 114.9,52.2 116.5,25.3  "
  })), _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "118.4,25.3 116.8,52.2 115.9,52.2 117.4,25.3  "
  })), _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "119.3,25.3 117.8,52.2 116.8,52.2 118.4,25.3  "
  })), _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "120.3,25.3 118.7,52.2 117.8,52.2 119.3,25.3  "
  })), _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "121.2,25.3 119.6,52.2 118.7,52.2 120.3,25.3  "
  })), _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "122.1,25.3 120.6,52.2 119.6,52.2 121.2,25.3  "
  })), _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "123.1,25.3 121.5,52.2 120.6,52.2 122.1,25.3  "
  })), _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "124,25.3 122.5,52.2 121.5,52.2 123.1,25.3  "
  })), _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "125,25.3 123.4,52.2 122.5,52.2 124,25.3  "
  })), _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "125.9,25.3 124.4,52.2 123.4,52.2 125,25.3  "
  })), _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "126.9,25.3 125.3,52.2 124.4,52.2 125.9,25.3  "
  })), _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "127.6,29.6 126.2,52.2 125.3,52.2 126.9,25.3 127.6,25.3  "
  })), _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "127.6,45.9 127.2,52.2 126.2,52.2 127.6,29.6  "
  })), _polygon225 || (_polygon225 = /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "127.2,52.2 127.6,45.9 127.6,52.2  "
  })), _polygon226 || (_polygon226 = /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "95.6,11.9 95.2,18.3 95.2,11.9  "
  })), _polygon227 || (_polygon227 = /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "96.5,11.9 95.2,34.6 95.2,18.3 95.6,11.9  "
  })), _polygon228 || (_polygon228 = /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "97.5,11.9 95.7,42.7 95.2,42.7 95.2,34.6 96.5,11.9  "
  })), _polygon229 || (_polygon229 = /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "98.4,11.9 96.6,42.7 95.7,42.7 97.5,11.9  "
  })), _polygon230 || (_polygon230 = /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "99.4,11.9 97.6,42.7 96.6,42.7 98.4,11.9  "
  })), _polygon231 || (_polygon231 = /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "100.3,11.9 98.5,42.7 97.6,42.7 99.4,11.9  "
  })), _polygon232 || (_polygon232 = /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "101.3,11.9 99.5,42.7 98.5,42.7 100.3,11.9  "
  })), _polygon233 || (_polygon233 = /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "102.2,11.9 100.4,42.7 99.5,42.7 101.3,11.9  "
  })), _polygon234 || (_polygon234 = /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "103.1,11.9 101.4,42.7 100.4,42.7 102.2,11.9  "
  })), _polygon235 || (_polygon235 = /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "104.1,11.9 102.3,42.7 101.4,42.7 103.1,11.9  "
  })), _polygon236 || (_polygon236 = /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "105,11.9 103.2,42.7 102.3,42.7 104.1,11.9  "
  })), _polygon237 || (_polygon237 = /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "105.1,27 104.2,42.7 103.2,42.7 105,11.9 105.1,11.9  "
  })), _polygon238 || (_polygon238 = /*#__PURE__*/React.createElement("polygon", {
    className: "st135",
    points: "104.2,42.7 105.1,27 105.1,42.7  "
  })), _polygon239 || (_polygon239 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "86.9,15.4 86.8,17.8 86.8,15.4  "
  })), _polygon240 || (_polygon240 = /*#__PURE__*/React.createElement("polygon", {
    className: "st137",
    points: "87.9,15.4 87.6,20.7 86.8,20.7 86.8,17.8 86.9,15.4  "
  })), _polygon241 || (_polygon241 = /*#__PURE__*/React.createElement("polygon", {
    className: "st138",
    points: "88.8,15.4 88.5,20.7 87.6,20.7 87.9,15.4  "
  })), _polygon242 || (_polygon242 = /*#__PURE__*/React.createElement("polygon", {
    className: "st139",
    points: "89.7,15.4 89.4,20.7 88.5,20.7 88.8,15.4  "
  })), _polygon243 || (_polygon243 = /*#__PURE__*/React.createElement("polygon", {
    className: "st140",
    points: "90.7,15.4 90.4,20.7 89.4,20.7 89.7,15.4  "
  })), _polygon244 || (_polygon244 = /*#__PURE__*/React.createElement("polygon", {
    className: "st141",
    points: "91.6,15.4 91.3,20.7 90.4,20.7 90.7,15.4  "
  })), _polygon245 || (_polygon245 = /*#__PURE__*/React.createElement("polygon", {
    className: "st142",
    points: "91.3,20.7 91.6,15.4 92.1,15.4 92.1,20.7  "
  })), _polygon246 || (_polygon246 = /*#__PURE__*/React.createElement("polygon", {
    className: "st138",
    points: "88.2,25.3 87.4,39.6 87.4,25.3  "
  })), _polygon247 || (_polygon247 = /*#__PURE__*/React.createElement("polygon", {
    className: "st139",
    points: "89.2,25.3 88.2,42.7 87.4,42.7 87.4,39.6 88.2,25.3  "
  })), _polygon248 || (_polygon248 = /*#__PURE__*/React.createElement("polygon", {
    className: "st140",
    points: "90.1,25.3 89.1,42.7 88.2,42.7 89.2,25.3  "
  })), _polygon249 || (_polygon249 = /*#__PURE__*/React.createElement("polygon", {
    className: "st141",
    points: "91.1,25.3 90.1,42.7 89.1,42.7 90.1,25.3  "
  })), _polygon250 || (_polygon250 = /*#__PURE__*/React.createElement("polygon", {
    className: "st142",
    points: "91.4,35.1 91,42.7 90.1,42.7 91.1,25.3 91.4,25.3  "
  })), _polygon251 || (_polygon251 = /*#__PURE__*/React.createElement("polygon", {
    className: "st143",
    points: "91,42.7 91.4,35.1 91.4,42.7  "
  })), _polygon252 || (_polygon252 = /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "76.4,18.9 75.8,28.8 75.8,18.9  "
  })), _polygon253 || (_polygon253 = /*#__PURE__*/React.createElement("polygon", {
    className: "st145",
    points: "77.3,18.9 75.9,42.7 75.8,42.7 75.8,28.8 76.4,18.9  "
  })), _polygon254 || (_polygon254 = /*#__PURE__*/React.createElement("polygon", {
    className: "st146",
    points: "78.2,18.9 76.9,42.7 75.9,42.7 77.3,18.9  "
  })), _polygon255 || (_polygon255 = /*#__PURE__*/React.createElement("polygon", {
    className: "st147",
    points: "79.2,18.9 77.8,42.7 76.9,42.7 78.2,18.9  "
  })), _polygon256 || (_polygon256 = /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "80.1,18.9 78.7,42.7 77.8,42.7 79.2,18.9  "
  })), _polygon257 || (_polygon257 = /*#__PURE__*/React.createElement("polygon", {
    className: "st149",
    points: "81.1,18.9 79.7,42.7 78.7,42.7 80.1,18.9  "
  })), _polygon258 || (_polygon258 = /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "82,18.9 80.6,42.7 79.7,42.7 81.1,18.9  "
  })), _polygon259 || (_polygon259 = /*#__PURE__*/React.createElement("polygon", {
    className: "st151",
    points: "83,18.9 81.6,42.7 80.6,42.7 82,18.9  "
  })), _polygon260 || (_polygon260 = /*#__PURE__*/React.createElement("polygon", {
    className: "st152",
    points: "83.9,18.9 82.5,42.7 81.6,42.7 83,18.9  "
  })), _polygon261 || (_polygon261 = /*#__PURE__*/React.createElement("polygon", {
    className: "st153",
    points: "84.7,21.9 83.5,42.7 82.5,42.7 83.9,18.9 84.7,18.9  "
  })), _polygon262 || (_polygon262 = /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "84.7,38.1 84.4,42.7 83.5,42.7 84.7,21.9  "
  })), _polygon263 || (_polygon263 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "84.4,42.7 84.7,38.1 84.7,42.7  "
  })), _polygon264 || (_polygon264 = /*#__PURE__*/React.createElement("polygon", {
    className: "st155",
    points: "55.3,25.3 54.6,37.4 54.6,25.3  "
  })), _polygon265 || (_polygon265 = /*#__PURE__*/React.createElement("polygon", {
    className: "st156",
    points: "56.2,25.3 55.2,42.7 54.6,42.7 54.6,37.4 55.3,25.3  "
  })), _polygon266 || (_polygon266 = /*#__PURE__*/React.createElement("polygon", {
    className: "st157",
    points: "57.1,25.3 56.1,42.7 55.2,42.7 56.2,25.3  "
  })), _polygon267 || (_polygon267 = /*#__PURE__*/React.createElement("polygon", {
    className: "st158",
    points: "58.1,25.3 57.1,42.7 56.1,42.7 57.1,25.3  "
  })), _polygon268 || (_polygon268 = /*#__PURE__*/React.createElement("polygon", {
    className: "st159",
    points: "59,25.3 58,42.7 57.1,42.7 58.1,25.3  "
  })), _polygon269 || (_polygon269 = /*#__PURE__*/React.createElement("polygon", {
    className: "st160",
    points: "60,25.3 59,42.7 58,42.7 59,25.3  "
  })), _polygon270 || (_polygon270 = /*#__PURE__*/React.createElement("polygon", {
    className: "st161",
    points: "60.9,25.3 59.9,42.7 59,42.7 60,25.3  "
  })), _polygon271 || (_polygon271 = /*#__PURE__*/React.createElement("polygon", {
    className: "st162",
    points: "61.9,25.3 60.8,42.7 59.9,42.7 60.9,25.3  "
  })), _polygon272 || (_polygon272 = /*#__PURE__*/React.createElement("polygon", {
    className: "st163",
    points: "62.8,25.3 61.8,42.7 60.8,42.7 61.9,25.3  "
  })), _polygon273 || (_polygon273 = /*#__PURE__*/React.createElement("polygon", {
    className: "st164",
    points: "63.7,25.3 62.7,42.7 61.8,42.7 62.8,25.3  "
  })), _polygon274 || (_polygon274 = /*#__PURE__*/React.createElement("polygon", {
    className: "st165",
    points: "64.7,25.3 63.7,42.7 62.7,42.7 63.7,25.3  "
  })), _polygon275 || (_polygon275 = /*#__PURE__*/React.createElement("polygon", {
    className: "st166",
    points: "65.6,25.3 64.6,42.7 63.7,42.7 64.7,25.3  "
  })), _polygon276 || (_polygon276 = /*#__PURE__*/React.createElement("polygon", {
    className: "st167",
    points: "66.6,25.3 65.6,42.7 64.6,42.7 65.6,25.3  "
  })), _polygon277 || (_polygon277 = /*#__PURE__*/React.createElement("polygon", {
    className: "st168",
    points: "67.5,25.3 66.5,42.7 65.6,42.7 66.6,25.3  "
  })), _polygon278 || (_polygon278 = /*#__PURE__*/React.createElement("polygon", {
    className: "st169",
    points: "68.5,25.3 67.4,42.7 66.5,42.7 67.5,25.3  "
  })), _polygon279 || (_polygon279 = /*#__PURE__*/React.createElement("polygon", {
    className: "st170",
    points: "69.4,25.3 68.4,42.7 67.4,42.7 68.5,25.3  "
  })), _polygon280 || (_polygon280 = /*#__PURE__*/React.createElement("polygon", {
    className: "st171",
    points: "70.3,25.3 69.3,42.7 68.4,42.7 69.4,25.3  "
  })), _polygon281 || (_polygon281 = /*#__PURE__*/React.createElement("polygon", {
    className: "st172",
    points: "71.3,25.3 70.3,42.7 69.3,42.7 70.3,25.3  "
  })), _polygon282 || (_polygon282 = /*#__PURE__*/React.createElement("polygon", {
    className: "st173",
    points: "72.2,25.3 71.2,42.7 70.3,42.7 71.3,25.3  "
  })), _polygon283 || (_polygon283 = /*#__PURE__*/React.createElement("polygon", {
    className: "st174",
    points: "73.2,25.3 72.2,42.7 71.2,42.7 72.2,25.3  "
  })), _polygon284 || (_polygon284 = /*#__PURE__*/React.createElement("polygon", {
    className: "st175",
    points: "74.1,25.3 73.1,42.7 72.2,42.7 73.2,25.3  "
  })), _polygon285 || (_polygon285 = /*#__PURE__*/React.createElement("polygon", {
    className: "st176",
    points: "74.7,32.1 74,42.7 73.1,42.7 74.1,25.3 74.7,25.3  "
  })), _polygon286 || (_polygon286 = /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "74,42.7 74.7,32.1 74.7,42.7  "
  })), _polygon287 || (_polygon287 = /*#__PURE__*/React.createElement("polygon", {
    className: "st177",
    points: "41.9,28.3 41.7,31.7 41,31.7 41,28.3  "
  })), _polygon288 || (_polygon288 = /*#__PURE__*/React.createElement("polygon", {
    className: "st178",
    points: "42.8,28.3 42.6,31.7 41.7,31.7 41.9,28.3  "
  })), _polygon289 || (_polygon289 = /*#__PURE__*/React.createElement("polygon", {
    className: "st179",
    points: "43.8,28.3 43.6,31.7 42.6,31.7 42.8,28.3  "
  })), _polygon290 || (_polygon290 = /*#__PURE__*/React.createElement("polygon", {
    className: "st180",
    points: "44.7,28.3 44.5,31.7 43.6,31.7 43.8,28.3  "
  })), _polygon291 || (_polygon291 = /*#__PURE__*/React.createElement("polygon", {
    className: "st181",
    points: "45.7,28.3 45.5,31.7 44.5,31.7 44.7,28.3  "
  })), _polygon292 || (_polygon292 = /*#__PURE__*/React.createElement("polygon", {
    className: "st182",
    points: "46.6,28.3 46.4,31.7 45.5,31.7 45.7,28.3  "
  })), _polygon293 || (_polygon293 = /*#__PURE__*/React.createElement("polygon", {
    className: "st183",
    points: "47.6,28.3 47.4,31.7 46.4,31.7 46.6,28.3  "
  })), _polygon294 || (_polygon294 = /*#__PURE__*/React.createElement("polygon", {
    className: "st184",
    points: "48.5,28.3 48.3,31.7 47.4,31.7 47.6,28.3  "
  })), _polygon295 || (_polygon295 = /*#__PURE__*/React.createElement("polygon", {
    className: "st185",
    points: "48.3,31.7 48.5,28.3 49.1,28.3 49.1,31.7  "
  })), _polygon296 || (_polygon296 = /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "36.5,24.7 36.4,26.1 36.4,24.7  "
  })), _polygon297 || (_polygon297 = /*#__PURE__*/React.createElement("polygon", {
    className: "st187",
    points: "37.4,24.7 36.4,42.4 36.4,26.1 36.5,24.7  "
  })), _polygon298 || (_polygon298 = /*#__PURE__*/React.createElement("polygon", {
    className: "st188",
    points: "38.3,24.7 37.3,43.3 36.4,43.3 36.4,42.4 37.4,24.7  "
  })), _polygon299 || (_polygon299 = /*#__PURE__*/React.createElement("polygon", {
    className: "st189",
    points: "39.3,24.7 38.2,43.3 37.3,43.3 38.3,24.7  "
  })), _polygon300 || (_polygon300 = /*#__PURE__*/React.createElement("polygon", {
    className: "st190",
    points: "40.2,24.7 39.1,43.3 38.2,43.3 39.3,24.7  "
  })), _polygon301 || (_polygon301 = /*#__PURE__*/React.createElement("polygon", {
    className: "st191",
    points: "41.2,24.7 40.1,43.3 39.1,43.3 40.2,24.7  "
  })), _polygon302 || (_polygon302 = /*#__PURE__*/React.createElement("polygon", {
    className: "st177",
    points: "42.1,24.7 41,43.3 40.1,43.3 41.2,24.7  "
  })), _polygon303 || (_polygon303 = /*#__PURE__*/React.createElement("polygon", {
    className: "st178",
    points: "43.1,24.7 42,43.3 41,43.3 42.1,24.7  "
  })), _polygon304 || (_polygon304 = /*#__PURE__*/React.createElement("polygon", {
    className: "st179",
    points: "44,24.7 42.9,43.3 42,43.3 43.1,24.7  "
  })), _polygon305 || (_polygon305 = /*#__PURE__*/React.createElement("polygon", {
    className: "st180",
    points: "44.9,24.7 43.9,43.3 42.9,43.3 44,24.7  "
  })), _polygon306 || (_polygon306 = /*#__PURE__*/React.createElement("polygon", {
    className: "st181",
    points: "45.9,24.7 44.8,43.3 43.9,43.3 44.9,24.7  "
  })), _polygon307 || (_polygon307 = /*#__PURE__*/React.createElement("polygon", {
    className: "st182",
    points: "46.8,24.7 45.7,43.3 44.8,43.3 45.9,24.7  "
  })), _polygon308 || (_polygon308 = /*#__PURE__*/React.createElement("polygon", {
    className: "st183",
    points: "47.8,24.7 46.7,43.3 45.7,43.3 46.8,24.7  "
  })), _polygon309 || (_polygon309 = /*#__PURE__*/React.createElement("polygon", {
    className: "st184",
    points: "48.7,24.7 47.6,43.3 46.7,43.3 47.8,24.7  "
  })), _polygon310 || (_polygon310 = /*#__PURE__*/React.createElement("polygon", {
    className: "st185",
    points: "49.6,24.7 48.6,43.3 47.6,43.3 48.7,24.7  "
  })), _polygon311 || (_polygon311 = /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "50.6,24.7 49.5,43.3 48.6,43.3 49.6,24.7  "
  })), _polygon312 || (_polygon312 = /*#__PURE__*/React.createElement("polygon", {
    className: "st193",
    points: "51.5,24.7 50.5,43.3 49.5,43.3 50.6,24.7  "
  })), _polygon313 || (_polygon313 = /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "52.5,24.7 51.4,43.3 50.5,43.3 51.5,24.7  "
  })), _polygon314 || (_polygon314 = /*#__PURE__*/React.createElement("polygon", {
    className: "st195",
    points: "53.4,25.5 52.3,43.3 51.4,43.3 52.5,24.7 53.4,24.7  "
  })), _polygon315 || (_polygon315 = /*#__PURE__*/React.createElement("polygon", {
    className: "st196",
    points: "53.4,41.8 53.3,43.3 52.3,43.3 53.4,25.5  "
  })), _polygon316 || (_polygon316 = /*#__PURE__*/React.createElement("polygon", {
    className: "st155",
    points: "53.3,43.3 53.4,41.8 53.4,43.3  "
  })), _polygon317 || (_polygon317 = /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "19.1,15.1 19,17 19,15.1  "
  })), _polygon318 || (_polygon318 = /*#__PURE__*/React.createElement("polygon", {
    className: "st198",
    points: "20.1,15.1 19,33.3 19,17 19.1,15.1  "
  })), _polygon319 || (_polygon319 = /*#__PURE__*/React.createElement("polygon", {
    className: "st199",
    points: "21,15.1 19.4,42.7 19,42.7 19,33.3 20.1,15.1  "
  })), _polygon320 || (_polygon320 = /*#__PURE__*/React.createElement("polygon", {
    className: "st200",
    points: "21.9,15.1 20.3,42.7 19.4,42.7 21,15.1  "
  })), _polygon321 || (_polygon321 = /*#__PURE__*/React.createElement("polygon", {
    className: "st201",
    points: "22.9,15.1 21.3,42.7 20.3,42.7 21.9,15.1  "
  })), _polygon322 || (_polygon322 = /*#__PURE__*/React.createElement("polygon", {
    className: "st202",
    points: "23.8,15.1 22.2,42.7 21.3,42.7 22.9,15.1  "
  })), _polygon323 || (_polygon323 = /*#__PURE__*/React.createElement("polygon", {
    className: "st203",
    points: "24.8,15.1 23.2,42.7 22.2,42.7 23.8,15.1  "
  })), _polygon324 || (_polygon324 = /*#__PURE__*/React.createElement("polygon", {
    className: "st204",
    points: "25.7,15.1 24.1,42.7 23.2,42.7 24.8,15.1  "
  })), _polygon325 || (_polygon325 = /*#__PURE__*/React.createElement("polygon", {
    className: "st205",
    points: "26.7,15.1 25.1,42.7 24.1,42.7 25.7,15.1  "
  })), _polygon326 || (_polygon326 = /*#__PURE__*/React.createElement("polygon", {
    className: "st206",
    points: "27.6,15.1 26,42.7 25.1,42.7 26.7,15.1  "
  })), _polygon327 || (_polygon327 = /*#__PURE__*/React.createElement("polygon", {
    className: "st207",
    points: "28.5,15.1 26.9,42.7 26,42.7 27.6,15.1  "
  })), _polygon328 || (_polygon328 = /*#__PURE__*/React.createElement("polygon", {
    className: "st208",
    points: "29.5,15.1 27.9,42.7 26.9,42.7 28.5,15.1  "
  })), _polygon329 || (_polygon329 = /*#__PURE__*/React.createElement("polygon", {
    className: "st209",
    points: "30.4,15.1 28.8,42.7 27.9,42.7 29.5,15.1  "
  })), _polygon330 || (_polygon330 = /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "31.4,15.1 29.8,42.7 28.8,42.7 30.4,15.1  "
  })), _polygon331 || (_polygon331 = /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "32.3,15.1 30.7,42.7 29.8,42.7 31.4,15.1  "
  })), _polygon332 || (_polygon332 = /*#__PURE__*/React.createElement("polygon", {
    className: "st212",
    points: "33.2,15.1 31.6,42.7 30.7,42.7 32.3,15.1  "
  })), _polygon333 || (_polygon333 = /*#__PURE__*/React.createElement("polygon", {
    className: "st213",
    points: "34.2,15.1 32.6,42.7 31.6,42.7 33.2,15.1  "
  })), _polygon334 || (_polygon334 = /*#__PURE__*/React.createElement("polygon", {
    className: "st214",
    points: "35.1,15.1 33.5,42.7 32.6,42.7 34.2,15.1  "
  })), _polygon335 || (_polygon335 = /*#__PURE__*/React.createElement("polygon", {
    className: "st215",
    points: "35.9,18.6 34.5,42.7 33.5,42.7 35.1,15.1 35.9,15.1  "
  })), _polygon336 || (_polygon336 = /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "35.9,34.9 35.4,42.7 34.5,42.7 35.9,18.6  "
  })), _polygon337 || (_polygon337 = /*#__PURE__*/React.createElement("polygon", {
    className: "st187",
    points: "35.4,42.7 35.9,34.9 35.9,42.7  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c3ab3485.svg";
export { ForwardRef as ReactComponent };